// extracted by mini-css-extract-plugin
export default {"wrapper":"TeasePopupContent_wrapper__Nz03Q"};